import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Arrow from '../../Icons/Arrow';
import * as styles from './style';
import Item from '../Item';
import { PLACEHOLDER_COLOR } from '../../../styles/variables';
import { Checkbox } from '../../../styles/customComponents';

class Accordion extends Component {
  state = {
    isOpen: false,
  };

  toggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  toggleItems = (e, id, toggleAllItemsInAccordion) => {
    toggleAllItemsInAccordion(id);
    e.stopPropagation();
  };

  isAllChecked = () => {
    const { data } = this.props;
    return data.options.every(opt => opt.checked);
  };

  isSomeChecked = () => {
    const { data } = this.props;
    return data.options.some(opt => opt.checked);
  };

  render() {
    const { options, data, selectOption, leftCheckbox, toggleAllItemsInAccordion } = this.props;
    const arrowPosition = this.state.isOpen ? 'up' : 'down';
    return (
      <Fragment>
        <styles.ItemWrapper id={`accordion-${data.id}`}>
          <styles.TitleAccordion id={`toggle-accordion-${data.id}`} onClick={this.toggle}>
            {!!toggleAllItemsInAccordion && (
              <Checkbox
                id={`check-item-${data.id || ''}`}
                name={`check-item-${data.id || ''}`}
                checked={this.isAllChecked()}
                someChecked={this.isSomeChecked()}
                disabled={false}
                onClick={e => this.toggleItems(e, data.id, toggleAllItemsInAccordion)}
                customStyles={{ paddingLeft: 0 }}
              />
            )}
            <styles.Text>{data.name}</styles.Text>
            <styles.Button>
              <Arrow size={5} color={`${PLACEHOLDER_COLOR}`} position={arrowPosition} />
            </styles.Button>
          </styles.TitleAccordion>
          <styles.SubItemWrapper isOpen={this.state.isOpen}>
            {options.map(opt => (
              <Item
                key={opt.id}
                option={opt}
                fatherId={data.id}
                selectOption={selectOption}
                leftCheckbox={leftCheckbox}
              />
            ))}
          </styles.SubItemWrapper>
        </styles.ItemWrapper>
      </Fragment>
    );
  }
}

Accordion.propTypes = {
  options: PropTypes.array,
  selectOption: PropTypes.func,
  leftCheckbox: PropTypes.bool,
  toggleAllItemsInAccordion: PropTypes.func,
};

Accordion.defaultProps = {
  leftCheckbox: false,
  toggleAllItemsInAccordion: null,
};

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/GenericSelectList/Accordion/index.js